import React from 'react'
import DataCenter from './ICTinfrastructure/DataCenter'

const Services = () => {
  return (
    <div>
      <DataCenter/>
    </div>
  )
}

export default Services